import {
  BoxProps,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@elkaso-app/web-design';
import { SupplierProfileDto, useUnlinkSupplierProfileApi } from 'apis/supplier-profiles';
import React from 'react';

export interface IUnlinkSupplierModalCell extends BoxProps {
  trigger: JSX.Element;
  profile: SupplierProfileDto;
}

export const UnlinkSupplierModal = ({ trigger, profile }: IUnlinkSupplierModalCell) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate: unlinkSupplierProfile, isLoading } = useUnlinkSupplierProfileApi();

  const handleUnlink = () => {
    unlinkSupplierProfile({ id: profile.id }, { onSuccess: onClose });
  };

  return (
    <>
      {React.cloneElement(trigger, { onClick: onOpen })}

      <Modal isOpen={isOpen} onClose={onClose} size={{ base: 'full', md: 'md' }}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Unlink Supplier</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text fontSize='sm' color='gray.600'>
              Unlink the supplier <strong>{profile.supplier?.name ?? `#${profile.supplierId}`}</strong> from the
              profile <strong>{profile.businessName}</strong>? The supplier itself is not deleted and can be linked
              again later.
            </Text>
          </ModalBody>

          <ModalFooter>
            <HStack>
              <Button variant='outline' colorScheme='red' onClick={onClose}>
                Cancel
              </Button>
              <Button variant='solid' colorScheme='red' onClick={handleUnlink} isLoading={isLoading}>
                Unlink
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
